import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import { useNotification } from '@/shared/ui'
import { coordsToGeometry, geometryToCoords } from './helpers.ts'

/**
 * Функция загрузки списка координат объекта
 */
export const useLoadObjectCoords = (objectId: number, active: Ref<boolean>) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_object_coords', objectId],
    queryFn: async () => {
      const res = await http.get(`/api/v1/objects/${objectId}`)
      return { coordinates: geometryToCoords(res.data?.geometry) }
    },
    retry: false,
    enabled: active,
  })
}

/**
 * Функция отправки новых координат объекту
 */
export const useSendObjectCoords = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: { object_id: number; coordinates: number[][] }) =>
      http.put(`/api/v1/objects/${data.object_id}/geometry`, {
        geometry: coordsToGeometry(data.coordinates),
      }),
  })

  const save = async (objectId: number, coords: number[][]) => {
    try {
      return await mutation.mutateAsync({ object_id: objectId, coordinates: coords })
    } catch (error: any) {
      addError(
        trs(
          error?.response?.data?.data?.msg ||
            error?.response?.data?.error ||
            'request.unknown_error',
        ),
      )
    }
  }

  return {
    ...mutation,

    save,
  }
}
